import { Card, Typography } from "@mui/material";

import EntitiesOptionsTable from "./EntitiesOptionsTable/EntitiesOptionsTable";

// ----------------------------------------------------------------------

export default function EntitiesOptions() {
	return (
		<Card sx={{ mt: 4 }}>
			<Typography sx={{ mb: 2, px: 3, pt: 2 }} variant='h6'>
				{"Modifica las entidades"}
			</Typography>
			<EntitiesOptionsTable />
		</Card>
	);
}
